<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-now"
        viewBox="0 0 841.9 595.3"
        style="enable-background: new 0 0 841.9 595.3"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M618.7,295.4c11.1-4.7,22.3-6.9,35.2-6.9c51.3,0,92.8,41.6,92.8,92.8s-41.6,92.8-92.8,92.8    s-92.8-41.6-92.8-92.8c0-32.4,16.6-60.9,41.7-77.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M608.3,274.3c14.2-6.1,29.1-9.2,45.5-9.2c64.2,0,116.2,52,116.2,116.2s-52,116.2-116.2,116.2    s-116.2-52-116.2-116.2c0-41.2,21.9-77.7,54.2-98.4" />
            </g>
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M317.3,385.3c-12.2,51-57.9,88.5-112.6,88.5c-64.1,0-116.1-52-116.1-116.1s52-116.1,116.1-116.1    c41,0,77.1,21.3,97.7,53.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M306.8,302.4c9.1,16.5,13.9,35.1,13.9,55.3c0,5.4-0.4,10.6-1.1,15.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M340.7,390.6c-14.8,61.4-70.1,107-136,107c-77.3,0-139.9-62.6-139.9-139.9s62.6-139.9,139.9-139.9    c50.5,0,94.8,26.8,119.4,66.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M328.6,292.8c10.2,19.4,15.9,41.5,15.9,64.9c0,6.6-0.5,13-1.3,19.3" />
            </g>
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="593.9,234 598.6,247.8 578.2,255.1 576.7,249.8 404.2,394.4" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="563"
                y1="144.1"
                x2="588.3"
                y2="217.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M383.7,399.3c0,0-168.6-35.7-177.7-37.7c-9.1-2-16.7-8.6-2.2-18.4s145.4-69.4,145.4-69.4l-10.9-38.1l14.2-4.4   l3.3,12.2c0,0,25.1,0.4,37.2,0.2c12.2-0.2,24.4-0.4,41.5-14.4s104.4-89.8,104.4-89.8l-3.3-9l20.2-7.2l3.2,9.2" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M351.2,282.4c-0.7,0.2-116.7,52.2-126.2,56.5c-20.5,9.3-28,13.4-9,17.3c12.9,2.7,164.7,27.4,164.7,27.4   L351.2,282.4z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M360.1,257.6l33,116.8l176.2-147.9l-24.2-68.3c0,0-102,83.6-111.5,89.6s-20.6,10.2-39.5,10   C375.4,257.6,360.1,257.6,360.1,257.6z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M578.8,255.1l5.4,13.3c0,0,59.4,105.7,62.3,110.6c2.9,4.9,4.9,7.1,9.5,5.1c4.7-2,3.6-7.5,1.6-10.9   c-2-3.3-55.2-110.4-55.2-110.4l-3.8-15.1L578.8,255.1z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M640.4,237.1c0,0,2.3-13.5,3-15.4c1.7-4.5,4.1-7.8,20.5-8.3l58.7-2.2c0,0-1.2,7.2-9.5,9.5   S640.4,237.1,640.4,237.1z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M560.5,132.8c0,0-5.4,0.1-5.8,4.5c-0.4,4.8,3.2,6,8.4,6.5l21.3,1.4l10.9,56.5l-6.5,16.6c0,0-2.2,5.4-2.8,8.1   c-0.4,2.1,0.1,7.8,6.1,7.7c1.6,0,3-0.8,3.9-2.2l4.3-6.6c0,0,2.8,8.5,3.2,9.4s5.5,11,16.2,13c10.6,2,23.6-2.1,31.6-4   s60.5-13.1,68.9-17.2c8.4-4.1,13.1-14.4,13.3-18.7s-3.5-4.9-6.1-4.9s-59.1,2-70.7,2.4s-17.3,9.1-19.4,12.7   c-2.1,3.7-4.5,20.4-4.5,20.4s-0.9,0.5-9.3,1.1c-8.4,0.6-12.3-9.8-13.2-13.5s-17.5-82.6-18.3-92.2s4.7-15.9,8.2-19.3   s33.7-24.9,36.4-26.9s2.5-4.6,1.1-6.6s-3.5-2.4-5.9-0.9c-2.3,1.6-36.7,25.3-43.1,33.7s-5.4,23.3-5.4,23.3s-22.6-4.6-24.1-5" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M375.7,367.8l-23.5-21.5c0,0-3.4-2.5-7.4,0.8" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="345"
                y1="355.5"
                x2="367.9"
                y2="381.3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M383.7,399.3c0,0,33.9,30.6,41.9,37.9s10.4,3.8,12,2.4c1.6-1.3,3.5-5.3-2.4-10.9c-6-5.5-33.2-36.2-35.5-39   s-9.1-8.7-15.1-3.5C378,392,383.7,399.3,383.7,399.3z" />
        </g>
        <g class="handlebar-normal">
            <g>
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="537.4"
                    cy="76.7"
                    r="10.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M546.7,71.6c0,0,8.8,0,15,0s6,6.1,5.3,8.8c-0.7,2.7-5.6,17.4-6.9,20.8c-1.3,3.4-5.6,6.1-8.6,4.6    s-4-4.3-2.4-8.2c1.6-3.9,7-16.5,7-16.5h-8.5" />
            </g>
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M554.1,123.4c0,0-2.8-4.8-4.1-7s0.4-5.3,5.7-7.5c2.8-1.2,4.7-2,5.9-2.6c0.9-0.4,1.5-1.3,1.7-2.3l1.2-6.2    c0.2-0.9-0.3-1.9-1.1-2.3l-0.8-0.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M536.3,129.1c0,0-6.1-13.5-6.3-17c-0.2-3.4,0.8-6,6.5-9.9s14-8.8,14-8.8" />
            </g>
        </g>
        <g class="saddle-normal">
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M295.6,178.9c0,0,10.9,5.8,20.1,7.7c2.2,0.4,4.3,0.7,6.2,0.5c9.5-0.7,9.3-2.2,19-4c9.6-1.8,37.6-0.6,39-1.2   s0.5-10.9-10.6-12.2s-26.4,2-35.6,1.3c-9.3-0.7-28.7-3.2-36.8-1.8c-6.3,1.1-7.5,5.6-6.1,6.9C291.8,176.9,295.6,178.9,295.6,178.9z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M354.4,182.1c0,0-2.5,9-13.5,10s-16.5,1.3-20.3,0.3s-4.9-5.9-4.9-5.9" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="339.6"
                y1="234.6"
                x2="328.1"
                y2="193.2" />
            <line
                class="fill-none stroke-woom-black stroke-2"
                x1="350.6"
                y1="231.5"
                x2="340.2"
                y2="193.2" />
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="201"
                        y1="218.1"
                        x2="201"
                        y2="497.7" />
                    <g>
                        <rect
                            x="193.2"
                            y="217"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.2" />
                    </g>
                    <g>
                        <rect
                            x="193.2"
                            y="496.7"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="2.2" />
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="652.1"
                        y1="265.1"
                        x2="652.1"
                        y2="497.9" />
                    <g>
                        <rect
                            x="644.3"
                            y="264.2"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="1.9" />
                    </g>
                    <g>
                        <rect
                            x="644.3"
                            y="497.1"
                            class="fill-woom-red stroke-woom-red"
                            width="15.6"
                            height="1.9" />
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="536.9"
                    y1="78"
                    x2="536.9"
                    y2="497.6" />
                <g>
                    <rect
                        x="529.1"
                        y="76.7"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
                <g>
                    <rect
                        x="529.1"
                        y="496.5"
                        class="fill-woom-red stroke-woom-red"
                        width="15.6"
                        height="2.4" />
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        points="539.9,105.3 581.2,231.6 456.1,231.6" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M532.3,231.3c0-19.5,16.2-39.3,32.8-46.9" />
            </g>
            <g>
                <g>
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="584.7"
                        y1="238"
                        x2="708.4"
                        y2="490" />
                    <polyline
                        class="h-line fill-none stroke-woom-red stroke-3"
                        points="710.1,493.8 711.8,497.6 708.2,497.6" />
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="700.6"
                        y1="497.6"
                        x2="598.3"
                        y2="497.6" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="594.5"
                        y1="497.6"
                        x2="590.8"
                        y2="497.6" />
                </g>
            </g>
            <g>
                <g>
                    <path
                        class="h-line fill-none stroke-woom-red stroke-3"
                        d="M657.1,494.3c0-1.4,0.1-2.8,0.2-4.2" />
                    <path
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        d="M659,480.2c3.2-11.3,10.3-21.1,19.8-27.8" />
                    <path
                        class="h-line fill-none stroke-woom-red stroke-3"
                        d="M683.1,450c1.2-0.7,2.4-1.4,3.7-1.9" />
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="541.5"
                    y1="115.4"
                    x2="329.7"
                    y2="115.4" />
                <g>
                    <rect
                        x="540.3"
                        y="111.5"
                        class="fill-woom-red stroke-woom-red"
                        width="2.2"
                        height="7.8" />
                </g>
                <g>
                    <rect
                        x="328.7"
                        y="111.5"
                        class="fill-woom-red stroke-woom-red"
                        width="2.2"
                        height="7.8" />
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <line
                    class="h-line fill-none stroke-woom-red stroke-3"
                    x1="652.6"
                    y1="377.9"
                    x2="200.4"
                    y2="377.9" />
                <g>
                    <rect
                        x="651.6"
                        y="373.8"
                        class="fill-woom-red stroke-woom-red"
                        width="2.3"
                        height="8.2" />
                </g>
                <g>
                    <rect
                        x="199.3"
                        y="373.8"
                        class="fill-woom-red stroke-woom-red"
                        width="2.3"
                        height="8.2" />
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g class="inline">
                <polyline
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    points="347.4,239.6 419.8,496.5 176.6,497.6" />
            </g>
            <path
                class="h-line-miter fill-none stroke-woom-red stroke-3"
                d="M368.9,496.5c0-22.3,15.9-40.2,36.2-48.9" />
        </g>
        <g class="min-saddle-height hidden">
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M300.6,198c0,0,10.9,5.8,20.1,7.7c2.2,0.4,4.3,0.7,6.2,0.5c9.5-0.7,9.3-2.2,19-4c9.6-1.8,37.6-0.6,39-1.2    c1.4-0.7,0.5-10.9-10.6-12.2s-26.4,2-35.6,1.3s-28.7-3.2-36.8-1.8c-6.3,1.1-7.5,5.6-6.1,6.9C296.8,196,300.6,198,300.6,198z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M359.4,201.2c0,0-2.5,9-13.5,10s-16.5,1.3-20.3,0.3s-4.9-5.9-4.9-5.9" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="339.6"
                    y1="234.8"
                    x2="333.1"
                    y2="212.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="350.6"
                    y1="231.7"
                    x2="345.2"
                    y2="212.3" />
            </g>
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="335.9"
                            y1="188.5"
                            x2="330.8"
                            y2="188.5" />
                        <line
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            x1="320.3"
                            y1="188.5"
                            x2="33.8"
                            y2="188.5" />
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="28.8"
                            y1="188.5"
                            x2="23.5"
                            y2="188.5" />
                    </g>
                </g>
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="10"
                            y1="188.5"
                            x2="10"
                            y2="496.4" />
                        <g>
                            <rect
                                x="2"
                                y="187.3"
                                class="fill-woom-red stroke-woom-red"
                                width="16"
                                height="2.3" />
                        </g>
                        <g>
                            <rect
                                x="2"
                                y="495.3"
                                class="fill-woom-red stroke-woom-red"
                                width="16"
                                height="2.3" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M284.6,138c0,0,10.9,5.8,20.1,7.7c2.2,0.4,4.3,0.7,6.2,0.5c9.5-0.7,9.3-2.2,19-4c9.6-1.8,37.6-0.6,39-1.2    c1.4-0.7,0.5-10.9-10.6-12.2s-26.4,2-35.6,1.3s-28.7-3.2-36.8-1.8c-6.3,1.1-7.5,5.6-6.1,6.9C280.8,136,284.6,138,284.6,138z" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M343.4,141.2c0,0-2.5,9-13.5,10s-16.5,1.3-20.3,0.3s-4.9-5.9-4.9-5.9" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="339.6"
                    y1="234.8"
                    x2="317.1"
                    y2="152.3" />
                <line
                    class="fill-none stroke-woom-black stroke-2"
                    x1="350.6"
                    y1="231.7"
                    x2="329.2"
                    y2="152.3" />
            </g>
            <g>
                <g>
                    <line
                        class="h-dash-line fill-none stroke-woom-red stroke-3"
                        x1="320.3"
                        y1="128.5"
                        x2="33.8"
                        y2="128.5" />
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="28.8"
                        y1="128.5"
                        x2="23.5"
                        y2="128.5" />
                </g>
                <g>
                    <line
                        class="h-line fill-none stroke-woom-red stroke-3"
                        x1="10"
                        y1="128.5"
                        x2="10"
                        y2="496.4" />
                    <g>
                        <rect
                            x="2"
                            y="127.3"
                            class="fill-woom-red stroke-woom-red"
                            width="16"
                            height="2.3" />
                    </g>
                    <g>
                        <rect
                            x="2"
                            y="495.3"
                            class="fill-woom-red stroke-woom-red"
                            width="16"
                            height="2.3" />
                    </g>
                </g>
            </g>
        </g>
        <g class="crank-length hidden">
            <g class="inline">
                <line
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    x1="390"
                    y1="392.9"
                    x2="434"
                    y2="435.7" />
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="384.5,397.1 394.3,387.3 395.8,388.7 385.9,398.6" />
                </g>
                <g>
                    <polygon
                        class="fill-woom-red stroke-woom-red"
                        points="428.3,439.9 438.2,429.9 439.7,431.4 429.8,441.4" />
                </g>
            </g>
        </g>
        <g class="handlebar-adjustability hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line fill-none stroke-woom-red stroke-3"
                        points="595.3,94.9 539.5,110.3 572.7,63.5" />
                </g>
                <path
                    class="st13"
                    d="M553.5,90.5c8,1.4,10.4,5,9.5,12.8" />
            </g>
            <g>
                <circle
                    class="fill-none stroke-woom-black stroke-2"
                    cx="537.4"
                    cy="76.7"
                    r="10.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M546.7,71.6c0,0,8.8,0,15,0s6,6.1,5.3,8.8c-0.7,2.7-5.6,17.4-6.9,20.8c-1.3,3.4-5.6,6.1-8.6,4.6    s-4-4.3-2.4-8.2c1.6-3.9,7-16.5,7-16.5h-8.5" />
            </g>
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M554.1,123.4c0,0-2.8-4.8-4.1-7s0.4-5.3,5.7-7.5c2.8-1.2,4.7-2,5.9-2.6c0.9-0.4,1.5-1.3,1.7-2.3l1.2-6.2    c0.2-0.9-0.3-1.9-1.1-2.3l-0.8-0.5" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M536.3,129.1c0,0-6.1-13.5-6.3-17c-0.2-3.4,0.8-6,6.5-9.9s14-8.8,14-8.8" />
            </g>
        </g>
        <g class="stand-over-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="10.2"
                            y1="230.1"
                            x2="10.2"
                            y2="496.4" />
                        <g>
                            <rect
                                x="2"
                                y="228.9"
                                class="fill-woom-red stroke-woom-red"
                                width="16.4"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                x="2"
                                y="495.2"
                                class="fill-woom-red stroke-woom-red"
                                width="16.4"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="432.6"
                                y1="230"
                                x2="34.2"
                                y2="230" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="28.7"
                                y1="230"
                                x2="23.7"
                                y2="230" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
